import { appWithTranslation } from "next-i18next";
import nextI18NextConfig from "../../next-i18next.config";

import { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "@/store";
import "@/styles/globals.css";
import Cookies from "js-cookie";
import { useRouter } from "next/router";

function MyApp({ Component, pageProps }) {
  return (
    <Provider store={store}>
      <AppLogic />{" "}
      {/* 🚀 Hier wird die Logik innerhalb von Provider ausgeführt */}
      <Component {...pageProps} />
    </Provider>
  );
}

// ✅ **Hier läuft die Logik innerhalb von Provider**
function AppLogic() {
  const router = useRouter();

  // URL-Parameter speichern
  useEffect(() => {
    const { query } = router;
    const refParam = query.ref;
    if (refParam) {
      const currentReferral = Cookies.get("referral");
      if (currentReferral && !currentReferral.includes(refParam)) {
        const updatedReferral = `${currentReferral},${refParam}`;
        Cookies.set("referral", updatedReferral, { expires: 60 });
      } else if (!currentReferral) {
        Cookies.set("referral", refParam, { expires: 60 });
      }
    }
  }, [router.query]);

  return null;
}

export default appWithTranslation(MyApp, nextI18NextConfig);
